import { render, staticRenderFns } from "./AppsPage.vue?vue&type=template&id=5c9d8859&scoped=true"
import script from "./AppsPage.vue?vue&type=script&lang=ts"
export * from "./AppsPage.vue?vue&type=script&lang=ts"
import style0 from "./AppsPage.vue?vue&type=style&index=0&id=5c9d8859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d8859",
  null
  
)

export default component.exports